import * as cx from 'classnames';
import { ActionButton, ACTIONS } from 'mk/forms/ActionButton';
import { STATUS } from 'mk/forms/Uploader';
import { Context } from 'mk/interfaces';
import ImgCropped, { ImgCropMode } from 'mk2/components/ImgCropped';
import * as React from 'react';

const STRING_MAX_LENGTH = 30;

export interface OwnProps {
    context: Context;
    item: any;
    previewPhotoSize?: string;

    onCancel(id);
    onRotate(id);
}

export class PhotoPreview extends React.Component<OwnProps> {

    public render() {
        const { item, previewPhotoSize } = this.props;
        const status = item.status;
        let fileName;
        let fileSize = null;

        if (status !== STATUS.DONE && item.obj) {
            fileName = item.obj.name;
            if (fileName.length > STRING_MAX_LENGTH) {
                fileName = fileName.substr(0, STRING_MAX_LENGTH) + '...';
            }
            fileSize = Math.floor(item.obj.size / 1024);
        }

        return (
            <div className={cx('photo-preview', ['', 'new', 'sending', 'done', 'error'][status])}>
                {status !== STATUS.DONE && (
                    <div className="meta">
                        <div className="file-name">{fileName}</div>
                        <div className="size">({fileSize}kB)</div>
                    </div>
                )}
                {(status === STATUS.NEW || status === STATUS.SENDING) && (
                    <div className="progress-bar-wrapper">
                        <div className="progress-bar">
                            {item.progress > 0 && (
                                <div className="progress-value" style={{width: item.progress * 100 + '%'}} />
                            )}
                        </div>
                    </div>
                )}
                {status === STATUS.DONE && (
                    <div className="photo-img-wrapper">
                        <ImgCropped
                            className={cx('photo-img', 'orientation-' + item.orientation, 'aspect-' + item.aspect)}
                            photo={item}
                            photoVersion={previewPhotoSize}
                            width={100}
                            height={100}
                            mode={ImgCropMode.Cover}
                        />
                    </div>
                )}
                {status === STATUS.FAILED && <div className="error-msg">{item.errorMsg}</div>}
                <ActionButton action={ACTIONS.CANCEL} onClick={this.onCancel} />
                {status === STATUS.DONE && (
                    <ActionButton action={ACTIONS.ROTATE} onClick={this.onRotate} />
                )}
            </div>
        );
    }

    private onCancel = () => {
        this.props.onCancel(this.props.item.id);
    };

    private onRotate = () => {
        this.props.onRotate(this.props.item.id);
    };

}
